import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { Divider } from 'antd'
import styled from 'styled-components'

const QrQodeGuide = ({ title }) => {
  return (
    <>
      <Title>{title} </Title>
      <Divider />
      <ul>
        <TEXT>برای خوانده شدن بارکد نور صفحه را تا انتها زیاد کنید</TEXT>
        <TEXT>این بارکد، کارت ویزیت الکترونیک شهروندی شما محسوب می‌شود.</TEXT>
        <TEXT>
          به هنگام استفاده از بارکد، نام و شماره تماس شما به نمایش در می‌آید
        </TEXT>
      </ul>
    </>
  )
}

export default QrQodeGuide

const Title = styled.h5`
  font-size: ${fontSize.MEDIUM};
  margin-bottom: ${dimens.SPACING_XXS_NUDGE};
`

const TEXT = styled.li`
  list-style-type: disc;
  margin-right: ${dimens.SPACING_XL};
`
